import * as types from '../mutation-types'
import jobsRepository from '../../api/jobsRepository'

const state = {
    jobToCreate: {},
    jobToUpdate: {},
    jobs: [],
    job: {},
    isJobCreated: false,
    isJobUpdated: false,
    isJobDeleted: false
}

const getters = {
    jobToCreate: state => state.jobToCreate,
    jobToUpdate: state => state.jobToUpdate,
    jobs: state => state.jobs,
    job: state => state.job,
    isJobCreated: state => state.isJobCreated,
    isJobUpdated: state => state.isJobUpdated,
    isJobDeleted: state => state.isJobDeleted
}

const actions = {
    getJobs({ commit }) {
        return jobsRepository.getJobs().then((response) => {
            commit(types.SET_JOBS, response.data)
        })
    },
    getJob({ commit }, jobId) {
        return jobsRepository.getJob(jobId).then((response) => {
            commit(types.SET_JOB, response.data)
        })
    },
    createJob({ commit }) {
        return jobsRepository.createJob(state.jobToCreate).then((response) => {
            if (response.data.success) {
                commit(types.SET_JOB_CREATED, true)
                commit(types.ADD_JOB_TO_JOBS, response.data)
            } else {
                commit(types.SET_JOB_CREATED, false)
            }
        })
    },
    editJob({ commit }) {
        return jobsRepository.editJob(state.jobToUpdate).then((response) => {
            if (response.data.success) {
                commit(types.SET_JOB_UPDATED, true)
                commit(types.EDIT_JOB_IN_LIST, response.data.message)
            } else {
                commit(types.SET_JOB_UPDATED, false)
            }
        })
    },
    deleteJob({ commit }, jobId) {
        return jobsRepository.deleteJob(jobId).then((response) => {
            if (response.data.success) {
                commit(types.SET_JOB_DELETED, true)
                commit(types.REMOVE_JOB_FROM_JOBS, jobId)
            } else {
                commit(types.SET_JOB_DELETED, false)
            }
        })
    }
}

const mutations = {
    [types.SET_JOB_TO_CREATE](state, payload) {
        state.jobToCreate = payload
    },
    [types.SET_JOB_TO_UPDATE](state, payload) {
        state.jobToUpdate = payload
    },
    [types.SET_JOBS](state, payload) {
        state.jobs = payload
    },
    [types.SET_JOB](state, payload) {
        state.job = payload
    },
    [types.SET_JOB_CREATED](state, payload) {
        state.isJobCreated = payload
    },
    [types.SET_JOB_UPDATED](state, payload) {
        state.isJobUpdated = payload
    },
    [types.SET_JOB_DELETED](state, payload) {
        state.isJobDeleted = payload
    },
    [types.ADD_JOB_TO_JOBS](state, payload) {
        state.jobs.push(payload.message)
    },
    [types.EDIT_JOB_IN_LIST](state, payload) {
        state.jobs.forEach((job, index) => {
            if (job.id === payload.id) {
                state.jobs.splice(index, 1)
                state.jobs.push(payload)
            }
        })
    },
    [types.REMOVE_JOB_FROM_JOBS](state, payload) {
        state.jobs.forEach((job, index) => {
            if (job.id === payload) {
                state.jobs.splice(index, 1)
            }
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
